import React from 'react' 

const GalleryLoading = () => {
   return (
      <div className="GalleryLoading"> 
         <h2 className="animate-flicker">Carregando...</h2>
      </div>
   )
}

export default GalleryLoading;
